var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFriends(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M9.208 9.857a1.002 1.002 0 0 1-.228-.113A4.5 4.5 0 0 0 2.027 13H7.62c.338 0 .637.167.818.424a6.53 6.53 0 0 1 1.979-1.647 4.501 4.501 0 0 1-1.208-1.92zm-5.792-2.08a4.5 4.5 0 1 1 7.577-3.014 4.5 4.5 0 0 1 5.592 7.014A6.499 6.499 0 0 1 20 17.5c0 .086-.01.17-.032.25A1.002 1.002 0 0 1 19 19H8a1 1 0 0 1-.968-1.25A1.002 1.002 0 0 1 7 17.5c0-.886.177-1.73.498-2.5H1a1 1 0 0 1-.968-1.25A1.002 1.002 0 0 1 0 13.5a6.499 6.499 0 0 1 3.416-5.723zM6.5 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 4a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm4.473 6a4.5 4.5 0 0 0-8.946 0h8.946z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFriends);
export default __webpack_public_path__ + "static/media/icon-friends.b18e34d910a2cc0f827a5e83710a3708.svg";
export { ForwardRef as ReactComponent };